import posthog from "posthog-js";

/**
 * Initializes PostHog in the sidebar-chat app.
 *
 * When the sidebar is opened from the main client app, the main app passes its
 * PostHog session_id and distinct_id via URL params (phSessionId, phDistinctId).
 * Bootstrapping with these values stitches this sidebar's recording to the same
 * session visible in PostHog replays, so the full user journey is captured.
 */
export function initPostHog() {
    const key = process.env.REACT_APP_POSTHOG_KEY;
    if (!key) return;

    const isProd = process.env.REACT_APP_NODE_ENV === "prod";
    const params = new URLSearchParams(window.location.search);
    const sessionID = params.get("phSessionId");
    const distinctID = params.get("phDistinctId");

    posthog.init(key, {
        api_host: "https://us.i.posthog.com",
        person_profiles: "identified_only",
        // Parent app already tracks pageviews for the main session
        capture_pageview: false,
        capture_pageleave: false,
        disable_session_recording: !isProd,
        persistence: "localStorage",
        // Bootstrap with the parent session so recordings are stitched together
        bootstrap: sessionID && distinctID ? { sessionID, distinctID } : undefined,
    });
}

/**
 * Identifies the sidebar user in PostHog.
 * uid/email/name are already passed as URL params from the main app.
 */
export function identifyPostHogUser(uid, email, name) {
    if (!uid) return;
    try {
        posthog.identify(uid, { email, name });
    } catch {
        // posthog may not be initialized if no key is set
    }
}
